module.exports = __webpack_public_path__ + "img/50x50_kirmizi.22cc9bd7.gif";